
import React, { ChangeEvent } from 'react';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import {
  updateArticleHandler,
} from '../globals';

const FEATURE_PHOTO_INPUT_ID = "feature-photo__ctrl-src";

interface FeatureImageProps {
  imageSrc: string,
  editMode: boolean,
  fullWidth: boolean,
  displayImage: boolean,
  onFeatureImageChange: updateArticleHandler,
  onToggleUploader: () => void,
  onToggleFullWidth: (arg0: boolean) => void,
  onToggleImageDisplay: (arg0: boolean) => void,
}

class FeatureImage extends React.Component<FeatureImageProps, {}> {
  public refDisplayImage: React.RefObject<HTMLInputElement>
  public refFullWidthImage: React.RefObject<HTMLInputElement>

  constructor(props: FeatureImageProps) {
    super(props);
    this.refDisplayImage = React.createRef();
    this.refFullWidthImage = React.createRef();
  }

  render() {
    const { 
      props,
      refDisplayImage,
      refFullWidthImage,
    } = this;

    const {
      imageSrc,
      editMode,
      fullWidth,
      displayImage,
      onToggleUploader,
      onFeatureImageChange,
      onToggleFullWidth,
      onToggleImageDisplay,
    } = props;

    return (
      <div 
        className={`feature-photo ${displayImage? '' : 'feature-photo--hidden'}`}
      >
        {imageSrc && (
          <Image 
            className={`feature-photo__image ${fullWidth ? "feature-photo__image--full-width" : ""}`} 
            src={imageSrc} 
            thumbnail 
          /> 
        )}
        {editMode && ( 
          <>
            <div className="feature-photo__ctrl-wrapper">
              <Button 
                className="rounded-0 feature-photo__ctrl"
                variant="success"
                onClick={onToggleUploader}
              >
                Upload Image
              </Button>
              <input
                id={FEATURE_PHOTO_INPUT_ID}
                className="editable-input feature-photo__ctrl feature-photo__ctrl-src"
                type="text"
                value={imageSrc}
                onChange={(e: ChangeEvent<HTMLInputElement> ) => {
                  const newContent: string = e.target.value;
                  onFeatureImageChange(newContent);
                }}
              />
              <div className="feature-photo__ctrl">
                <Form.Check
                  type="switch"
                  id="toggle-image-display"
                  label="Display"
                  checked={displayImage}
                  ref={refDisplayImage as (string & React.RefObject<HTMLInputElement>)}
                  title="Select To display feature image on article page"
                  className="feature-photo__switch"
                  onChange={()=>{
                    onToggleImageDisplay(
                      (refDisplayImage.current as HTMLInputElement).checked
                    )
                  }}
                />
                <Form.Check
                  type="switch"
                  id="toggle-full-width-image"
                  label="Full Width"
                  checked={fullWidth}
                  ref={refFullWidthImage as (string & React.RefObject<HTMLInputElement>)}
                  title="Select to enable full with image"
                  className="feature-photo__switch"
                  onChange={()=>{
                    onToggleFullWidth(
                      (refFullWidthImage.current as HTMLInputElement).checked
                    )
                  }}
                />
              </div>
            </div>
            <div className="instructions instructions--feature-image">
              <p>Follow these instruction to set this articles feature image: </p>
              <ol>
                <li>
                  Click the "Upload Image" Button to upload an image to the server.
                  <ul>
                    <li>
                      On the popup that appears, select the "articles" folder
                      from the left panel labeled "Folders".
                    </li>
                    <li>
                      Click the "Upload" button (first button on the control bar at the top of the popup),
                      and select the image you would like to upload from the window that opens.
                    </li>
                    <li>
                      Once the image has been uploaded, close the popup.
                    </li>
                  </ul>
                </li>
                <li>
                  Once your image is on the server, select the input box next
                  to the "Upload Image" button.
                </li>
                <li>
                  Enter the URL to the Image you would like to select. The URL takes
                  the format "/fckimages/articles/[[ImageName]]". [[ImageName]]
                  should be replaced with the name of the image you uploaded 
                  (e.g. /fckimages/articles/aftermarket_parts_main.jpg).
                </li>
                <li>
                  Use the "Display" switch to hide or display the feature image on the
                  article view and the "Full Width" switch to toggle b/w thumbnail and
                  full width feature image.
                </li>
                <li>
                  When you are satisfied with the changes, click the save button (floppy disk)
                  on the "Content Editor" bar at the top of the screen and exit the editting
                  session.
                </li>
              </ol>
            </div>
          </>
        )}
      </div>
    )
  }
}

export default FeatureImage;